module.exports = __webpack_public_path__ + "fonts/Inter-Regular.c8ba52b.woff2";